$(function(){

  if($('.guest-referral-container').length){
    $('#a2a-share-plugin-block').html('<div class="a2a_kit a2a_kit_size_32 a2a_default_style" >' +
      '<a class="a2a_button_facebook landing-share-btn"><img src="/icons/share-icons/facebook-logo.svg" alt="Facebook"></a>' +
      '<a class="a2a_button_twitter landing-share-btn"><img src="/icons/share-icons/twitter-logo.svg" alt="Twitter"></a>' +
      '<a class="a2a_button_email landing-share-btn"><img src="/icons/share-icons/email-logo.svg" alt="Email"></a>' +
      '<a class="a2a_button_whatsapp landing-share-btn"><img src="/icons/share-icons/whatsapp-logo.svg" alt="Whatsapp"></a>' +
      '<a class="a2a_button_sms landing-share-btn"><img src="/icons/share-icons/sms-logo.svg" alt="Sms"></a>' +
      '</div>');

    a2a.init_all();
  }

  if($('.invite-referral-page-container').length){
    $('#a2a-share-plugin').html('<div class="a2a_kit a2a_kit_size_32 a2a_default_style" >' +
      '<a class="a2a_button_facebook landing-share-btn"><img src="/icons/share-icons/facebook-logo.svg" alt="Facebook"></a>' +
      '<a class="a2a_button_twitter landing-share-btn"><img src="/icons/share-icons/twitter-logo.svg" alt="Twitter"></a>' +
      '<a class="a2a_button_email landing-share-btn"><img src="/icons/share-icons/email-logo.svg" alt="Email"></a>' +
      '<a class="a2a_button_whatsapp landing-share-btn"><img src="/icons/share-icons/whatsapp-logo.svg" alt="Whatsapp"></a>' +
      '<a class="a2a_button_sms landing-share-btn"><img src="/icons/share-icons/sms-logo.svg" alt="Sms"></a>' +
      '</div>');

    a2a.init_all();
  }

  if($(".referral").length === 0) return

  const referralModal = createAsideModal({
    el: $('.referral-aside-modal'),
    size:700
  });

  request({
    url:'/referral/user-referral-details',
    data: {communityProgram: xProgram},
    callback(r){
      if(r.referralCode){

        $('.show-referral-modal, section.referral').show();
        $('[data-prop="code"]').text(r.referralCode)
        if(r.referralUrl)
        {
        $('[data-prop="link"]').text(r.referralUrl)
        $('.addition-referral-info a').attr('href',`/${xProgram}/referral`)
        }

        $('.referral-banner').click(function(){
          window.open(`/${xProgram}/referral`)
        });
        if(getParam('show-modal')){
          referralModal.show()
        }
        $('#a2a-share-plugin, #a2a-share-plugin-block').html('<div class="a2a_kit a2a_kit_size_32 a2a_default_style"  data-a2a-url="'+r.referralUrl+'">' +
          '<a class="a2a_button_facebook landing-share-btn"><img src="/icons/share-icons/facebook-logo.svg" alt="Facebook"></a>' +
          '<a class="a2a_button_twitter landing-share-btn"><img src="/icons/share-icons/twitter-logo.svg" alt="Twitter"></a>' +
          '<a class="a2a_button_email landing-share-btn"><img src="/icons/share-icons/email-logo.svg" alt="Email"></a>' +
          '<a class="a2a_button_whatsapp landing-share-btn"><img src="/icons/share-icons/whatsapp-logo.svg" alt="Whatsapp"></a>' +
          '<a class="a2a_button_sms landing-share-btn"><img src="/icons/share-icons/sms-logo.svg" alt="Sms"></a>' +
          '</div>');
        a2a.init_all();
      }
    }
  })

  $('.show-referral-modal, .open-referral-modal').click(function(){
    referralModal.show();
  });

  $(".copy-referral-code").unbind('click').click(function() {
    copyToClipboard($(this).closest('div').find('span').text())
    $('.copy-referral-code').tooltip('enable');
    $('.copy-referral-code').tooltip('show');
    setTimeout(()=>{
      $('.copy-referral-code').tooltip('disable');
      $('.copy-referral-code').tooltip('hide');
    },1000)
  })
  $(".copy-referral-link").unbind('click').click(function() {
    copyToClipboard($(this).closest('div').find('span').text(),true)
    $('.copy-referral-link').tooltip('enable');
    $('.copy-referral-link').tooltip('show');
    setTimeout(()=>{
      $('.copy-referral-link').tooltip('disable');
      $('.copy-referral-link').tooltip('hide');
    },1000)
  })


})